import { render, staticRenderFns } from "./orderfrezee.vue?vue&type=template&id=771b103c&scoped=true"
import script from "./orderfrezee.vue?vue&type=script&lang=js"
export * from "./orderfrezee.vue?vue&type=script&lang=js"
import style0 from "./orderfrezee.vue?vue&type=style&index=0&id=771b103c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b103c",
  null
  
)

export default component.exports